module.exports = __webpack_public_path__ + "assets/mastercard-logo.9ea3d1d1.svg";